import z from "zod";
import { STAT_TYPES } from "./stat-types";
import { MARKET_KINDS } from "./config";

export const StatTypeSchema = z.enum(STAT_TYPES);

export const MarketKindSchema = z.enum(MARKET_KINDS);

// базовый outcome
export const BaseOutcomeSchema = z.object({
	id: z.string(),
	title: z.string(),
	onchain_id: z.string(),
  price: z.number(),
});

// MONEYLINE
export const MoneylineOutcomeSchema = BaseOutcomeSchema.extend({
  code: z.enum(["home", "away", "draw"]),
});

// TOTAL
export const TotalOutcomeSchema = BaseOutcomeSchema.extend({
  code: z.enum(["over", "under"]),
  value: z.number(),
  range: z
    .object({ min: z.number().optional(), max: z.number().optional() })
    .nullable()
    .optional(),
});

// SPREAD
export const SpreadOutcomeSchema = BaseOutcomeSchema.extend({
  code: z.enum(["home", "away"]),
  value: z.number(),
});

// YES/NO
export const YesNoOutcomeSchema = BaseOutcomeSchema.extend({
  code: z.enum(["yes", "no"]),
});

// EXACT_NUMBER
export const ExactNumberOutcomeSchema = BaseOutcomeSchema.extend({
  code: z.literal("exact"),
  value: z.number(),
});

// RANGE_BUCKET
export const RangeBucketOutcomeSchema = BaseOutcomeSchema.extend({
  code: z.literal("range"),
  range: z.object({
    min: z.number().optional(),
    max: z.number().optional(),
  }),
});

export const AnyOutcomeSchema = z.union([
	MoneylineOutcomeSchema,
	TotalOutcomeSchema,
	SpreadOutcomeSchema,
	YesNoOutcomeSchema,
	ExactNumberOutcomeSchema,
	RangeBucketOutcomeSchema,
]);

export const BaseOddsSnapshotSchema = z.object({
  sport_id: z.string(),
  event_id: z.string(),
  league_id: z.string(),
  bookmaker_key: z.string(),
  bookmaker_title: z.string(),
  market_kind: MarketKindSchema,
  market_id: z.string(),
  market_base_id: z.string(),
  market_onchain_id: z.string(),
  market_updated_at: z.coerce.date(),
  market_title: z.string(),
  event_major_reschedule_index: z.number(),
  stat_type: StatTypeSchema,
  market_participant_ids: z.array(z.string()),
});


// снапшоты по типам рынка

export const MoneylineOddsSnapshotSchema = BaseOddsSnapshotSchema.extend({
  market_kind: z.literal("moneyline"),
  outcomes: z.array(MoneylineOutcomeSchema),
});

export const TotalOddsSnapshotSchema = BaseOddsSnapshotSchema.extend({
  market_kind: z.literal("total"),
  outcomes: z.array(TotalOutcomeSchema),
});

export const SpreadOddsSnapshotSchema = BaseOddsSnapshotSchema.extend({
  market_kind: z.literal("spread"),
  outcomes: z.array(SpreadOutcomeSchema),
});

export const YesNoOddsSnapshotSchema = BaseOddsSnapshotSchema.extend({
  market_kind: z.literal("yes-no"),
  outcomes: z.array(YesNoOutcomeSchema),
});

export const ExactNumberOddsSnapshotSchema = BaseOddsSnapshotSchema.extend({
  market_kind: z.literal("exact-number"),
  outcomes: z.array(ExactNumberOutcomeSchema),
});

export const RangeBucketOddsSnapshotSchema = BaseOddsSnapshotSchema.extend({
  market_kind: z.literal("range-bucket"),
  outcomes: z.array(RangeBucketOutcomeSchema),
});

export const OddsSnapshotSchema = z.discriminatedUnion("market_kind", [
  MoneylineOddsSnapshotSchema,
  TotalOddsSnapshotSchema,
  SpreadOddsSnapshotSchema,
  YesNoOddsSnapshotSchema,
  ExactNumberOddsSnapshotSchema,
  RangeBucketOddsSnapshotSchema,
]);
